import { Image, Col, Row } from "antd";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";
// import "react-responsive-carousel/lib/styles/carousel.min.css";

const SingleCategory = ({
  CategoryDetails,
}: {
  CategoryDetails: any;
}): ReactElement => {
  const [getCategoryDetails, setCategoryDetails] = useState(undefined);

  useEffect(() => {
    // CategoryDetails();
    setCategoryDetails(CategoryDetails);
  }, [CategoryDetails]);

  return (
    <React.Fragment>
      <Row gutter={20}>
        <Col span={24}>
          <Image
            height={200}
            src={getCategoryDetails?.image}
            className="rounded"
          />
        </Col>
        <Col span={24}>
          <h3 className="title">Basic Information</h3>
          <div className="inner-body-wrapper">
            <div className="inner-body">
              <div className="single">
                <div className="info-name">
                  <span>Category Title</span>
                </div>
                <div className="info-desc">
                  <span>{getCategoryDetails?.title}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Slug</span>
                </div>
                <div className="info-desc">
                  <span>{getCategoryDetails?.slug}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>ID</span>
                </div>
                <div className="info-desc">
                  <span>{getCategoryDetails?.id}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Keyword</span>
                </div>
                <div className="info-desc">
                  <span>{getCategoryDetails?.keyword}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Description</span>
                </div>
                <div className="info-desc">
                  <span>{getCategoryDetails?.description}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Position</span>
                </div>
                <div className="info-desc">
                  <span>{getCategoryDetails?.CategoryPosition}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Level</span>
                </div>
                <div className="info-desc">
                  <span>{getCategoryDetails?.level}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Parent ID</span>
                </div>
                <div className="info-desc">
                  <span>{getCategoryDetails?.parent}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Type</span>
                </div>

                <div className="info-desc">
                  <span>{`${getCategoryDetails?.type?.replace(
                    "_",
                    " "
                  )}`}</span>
                </div>
              </div>

              <div className="single">
                <div className="info-name">
                  <span>Status</span>
                </div>
                <div className="info-desc">
                  {getCategoryDetails?.status}
                  <span
                    className={`radius-btn ${
                      getCategoryDetails?.status === "true"
                        ? "active"
                        : "inactive"
                    }-btn`}
                  >
                    {getCategoryDetails?.status === "true"
                      ? "Active"
                      : "Inactive"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};
SingleCategory.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default SingleCategory;
